import React, { useState, useEffect, useRef } from "react";
import Navbar from "./Navbar";
import emailjs from "emailjs-com";
import "./App.css";

function App() {
	const [visibleProfileImage, setVisibleProfileImage] = useState(1);
	const formRef = useRef();
	const [status, setStatus] = useState("");
	const [isFadingOut, setIsFadingOut] = useState(false);

	useEffect(() => {
		const intervalId = setInterval(() => {
			setVisibleProfileImage((current) => (current === 1 ? 2 : 1));
		}, 10000);

		return () => clearInterval(intervalId);
	}, []);

	const sendEmail = (e) => {
		e.preventDefault();
		emailjs
			.sendForm(
				process.env.REACT_APP_EMAILJS_SERVICE_ID,
				process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
				formRef.current,
				process.env.REACT_APP_EMAILJS_USER_ID,
			)
			.then(
				() => {
					setStatus(
						"Thank you for your message! Gabriel will get back to you shortly.",
					);
					setIsFadingOut(false);
					formRef.current.reset();
					setTimeout(() => {
						setIsFadingOut(true);
						setTimeout(() => setStatus(""), 300);
					}, 4700);
				},
				(err) => setStatus(`Error: ${err.text}`),
			);
	};

	return (
		<div className="app-container">
			<Navbar />
			<main className="main-content">
				<section className="about-section">
					<div className="about-image">
						<img
							src="/ghigazi1.jpg"
							alt="Profile Version 1"
							className={`profile-image ${visibleProfileImage === 1 ? "visible" : ""}`}
						/>
						<img
							src="/ghigazi2.jpg"
							alt="Profile Version 2"
							className={`profile-image ${visibleProfileImage === 2 ? "visible" : ""}`}
						/>
					</div>
					<div className="about-text">
						<h1>First Philosophy Institute</h1>
						<p>
							First Philosophy Institute was created on the idea that philosophy
							is not just a subject but a way of living and thinking that opens
							the mind and deepens the soul. We are currently running our first
							classes and helping students engage with the timeless questions of
							knowledge, reality, and ethical theories. At the same time, we are
							developing new courses in areas like metaphysics, personal
							identity, and eastern philosophy. We are always aiming to make
							philosophy accessible, challenging, and transformative. Currently,
							all of our classes are being taught online through Zoom.
						</p>
						<br />
						<h1>About Me</h1>
						<p>
							Gabriel Higazi has a philosophy specialization at the University
							of Toronto with a minor in English. While his academic background
							is mainly philosophy, he has been involved in debate and public
							speaking since elementary school. Ever since Gabriel's first year
							of university, he has been obsessed with philosophy and the power
							it has to reshape our individual understanding of the world.
						</p>
					</div>
				</section>

				<section className="classes-section">
					<h2>Available Classes</h2>
					<div className="class-posters-container">
						<div>
							<h4>Deep Thinkers</h4>
							<div className="class-poster-item">
								<img
									src="/deep_thinkers_1.png"
									alt="Deep Thinkers Poster - Front"
									className="poster-image"
								/>
								<img
									src="/deep_thinkers_2.png"
									alt="Deep Thinkers Poster - Back"
									className="poster-image"
								/>
							</div>
						</div>
						<div>
							<h4>Ethical Explorers</h4>
							<div className="class-poster-item">
								<img
									src="ethical_explorers_1.png"
									alt="Ethical Explorers - Front"
									className="poster-image"
								/>
								<img
									src="/ethical_explorers_2.png"
									alt="Ethical Explorers - Back"
									className="poster-image"
								/>
							</div>
						</div>
					</div>
				</section>

				<section className="contact-section">
					<h2>Contact Me</h2>
					<form ref={formRef} onSubmit={sendEmail} className="contact-form">
						<div className="form-group">
							<label htmlFor="name">Name:</label>
							<input type="text" id="name" name="user_name" required />
						</div>
						<div className="form-group">
							<label htmlFor="email">Your Email:</label>
							<input type="email" id="email" name="user_email" required />
						</div>
						<div className="form-group">
							<label htmlFor="message">Message:</label>
							<textarea id="message" name="message" rows="5" required />
						</div>
						<button type="submit" className="submit-button">
							Send Message
						</button>
						{status && (
							<p
								className={`form-note ${
									status.includes("Thank you")
										? "success-message"
										: "error-message"
								} ${isFadingOut ? "fade-out" : ""}`}
							>
								{status}
							</p>
						)}
					</form>
				</section>
			</main>
		</div>
	);
}

export default App;
